module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-1-9f57b1fb7fd83a1039e8ca0f5d6c6168.jpg";